define(["./commonsOptimizationModule"], function (commonsOptimizationModule) {
    "use strict";

    return commonsOptimizationModule.service("optimizationServiceInvoker", [function () {
        var optimizationService;
        return {
            optimize: function (trips, orders, config, restrictions) {
                if (!optimizationService) {
                    throw new Error("Service for optimization was not injected.");
                }
                return optimizationService(trips, orders, config, restrictions);
            },
            setService: function (service) {
                optimizationService = service;
            }
        };
    }]);
});